import { render } from "./EditTypeUser.vue?vue&type=template&id=97a82eea&scoped=true"
import script from "./EditTypeUser.vue?vue&type=script&lang=js"
export * from "./EditTypeUser.vue?vue&type=script&lang=js"

import "./EditTypeUser.vue?vue&type=style&index=0&id=97a82eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a82eea"]])

export default __exports__